import { isMockAudioCaseFileId, MOCK_FAILING_AUDIO_CASE_FILE_ID } from '@/store/slices/cases/mockAudioCaseFile';

export type TranscriptionOutcome = 'completed' | 'failed';

/** How long a mock recording takes to transcribe. */
export const MOCK_TRANSCRIPTION_DURATION_MS = 30 * 1000;

/**
 * How a requested transcription ended, or `null` while it's still running. The BE doesn't report
 * this yet, so only the mock recordings finish, a fixed time after the request: the failing one
 * fails, the rest complete. Replace with the BE status once available.
 */
export function getTranscriptionOutcome(
  documentId: string,
  requestedAt: number,
  now: number = Date.now(),
): TranscriptionOutcome | null {
  if (!isMockAudioCaseFileId(documentId) || now - requestedAt < MOCK_TRANSCRIPTION_DURATION_MS) return null;
  return documentId === MOCK_FAILING_AUDIO_CASE_FILE_ID ? 'failed' : 'completed';
}
